<div class="store-details-help-popover">
  <section class="store-details-help-popover__body">
    <p class="store-details-help-popover__title">
      {{ 'stores.forms.steps.storeDetails.title' | translate }}
    </p>
    <p class="store-details-help-popover__description">
      {{ 'stores.forms.steps.storeDetails.description' | translate }}
    </p>
    <ul class="store-details-help-popover__list">
      <li>{{ 'stores.forms.steps.storeDetails.bullet1' | translate }}</li>
      <li>{{ 'stores.forms.steps.storeDetails.bullet2' | translate }}</li>
      <li>{{ 'stores.forms.steps.storeDetails.bullet3' | translate }}</li>
    </ul>
  </section>
</div>
